import React from 'react'
import CookieConsent from 'react-cookie-consent'

export default () => (
  <CookieConsent
    location="bottom"
    buttonText="&nbsp;OK&nbsp;"
    style={{ backgroundColor: 'rgba(248,249,250, 0.9)', color: '#555' }}
    buttonStyle={{ background: '#7AE8C5', color: '#f9f9f9', borderRadius: '8px', fontSize: '14px', opacity: '1'  }}
    acceptOnScroll={true}
  >
    <p>
      We use cookies to make your exploring a better experience. Please see our{' '}
      <a href="https://www.iubenda.com/privacy-policy/62935083" rel="nofollow noopener noreferrer" target="_blank">
        cookie policy
      </a>
      .
    </p>
  </CookieConsent>
)
